import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getFiels = createAsyncThunk(
  "Shared/getFiels",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/employee_file_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddFiels = createAsyncThunk(
  "Shared/AddFiels",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/employee_file_types`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getBanks = createAsyncThunk(
  "Shared/getBanks",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/banks`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddBank = createAsyncThunk(
  "Shared/AddBank",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/banks`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getEducation = createAsyncThunk(
  "Shared/getEducation",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/academic_degrees`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddEducation = createAsyncThunk(
  "Shared/AddEducation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/academic_degrees`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueStatus = createAsyncThunk(
  "Shared/getIssueStatus",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/issue_status`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueStatus = createAsyncThunk(
  "Shared/AddIssueStatus",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/issue_status`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateIssueStatus = createAsyncThunk(
  "Shared/updateIssueStatus",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/issue_status/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteIssueStatus = createAsyncThunk(
  "Shared/deleteIssueStatus",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/issue_status/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getLitigationDegrees = createAsyncThunk(
  "Shared/getLitigationDegrees",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/litigation_degrees`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddLitigationDegrees = createAsyncThunk(
  "Shared/AddLitigationDegrees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/litigation_degrees`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateLitigationDegrees = createAsyncThunk(
  "Shared/updateLitigationDegrees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/litigation_degrees/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteLitigationDegrees = createAsyncThunk(
  "Shared/deleteLitigationDegrees",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/litigation_degrees/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueTypes = createAsyncThunk(
  "Shared/getIssueTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/issue_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueTypes = createAsyncThunk(
  "Shared/AddIssueTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/issue_types`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateIssueTypes = createAsyncThunk(
  "Shared/updateIssueTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/issue_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteIssueTypes = createAsyncThunk(
  "Shared/deleteIssueTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/issue_types/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCourts = createAsyncThunk(
  "Shared/getCourts",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/courts`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddCourts = createAsyncThunk(
  "Shared/AddCourts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/courts`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateCourts = createAsyncThunk(
  "Shared/updateCourts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/courts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCourts = createAsyncThunk(
  "Shared/deleteCourts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/courts/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getAttributes = createAsyncThunk(
  "Shared/getAttributes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/attributes`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddAttributes = createAsyncThunk(
  "Shared/AddAttributes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/attributes`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateAttributes = createAsyncThunk(
  "Shared/updateAttributes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/attributes/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteAttributes = createAsyncThunk(
  "Shared/deleteAttributes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/attributes/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueDetailStatus = createAsyncThunk(
  "Shared/getIssueDetailStatus",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/issue_detail_status`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueDetailStatus = createAsyncThunk(
  "Shared/AddIssueDetailStatus",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/issue_detail_status`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateIssueDetailStatus = createAsyncThunk(
  "Shared/updateIssueDetailStatus",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/issue_detail_status/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteIssueDetailStatus = createAsyncThunk(
  "Shared/deleteIssueDetailStatus",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/issue_detail_status/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getSessionTypes = createAsyncThunk(
  "Shared/getSessionTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/session_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddSessionTypes = createAsyncThunk(
  "Shared/AddSessionTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/session_types`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateSessionTypes = createAsyncThunk(
  "Shared/updateSessionTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/session_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteSessionTypes = createAsyncThunk(
  "Shared/deleteSessionTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/session_types/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getDocumentTypes = createAsyncThunk(
  "Shared/getDocumentTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/document_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddDocumentTypes = createAsyncThunk(
  "Shared/AddDocumentTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/document_types`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateDocumentTypes = createAsyncThunk(
  "Shared/updateDocumentTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/document_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteDocumentTypes = createAsyncThunk(
  "Shared/deleteDocumentTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/document_types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getImplementationTypes = createAsyncThunk(
  "Shared/getImplementationTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/implementation_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddImplementationTypes = createAsyncThunk(
  "Shared/AddImplementationTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_types`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateImplementationTypes = createAsyncThunk(
  "Shared/updateImplementationTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteImplementationTypes = createAsyncThunk(
  "Shared/deleteImplementationTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getImplementationPlaces = createAsyncThunk(
  "Shared/getImplementationPlaces",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/implementation_places`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddImplementationPlaces = createAsyncThunk(
  "Shared/AddImplementationPlaces",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_places`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateImplementationPlaces = createAsyncThunk(
  "Shared/updateImplementationPlaces",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_places/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteImplementationPlaces = createAsyncThunk(
  "Shared/deleteImplementationPlaces",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/implementation_places/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCommissionTypes = createAsyncThunk(
  "Shared/getCommissionTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/commission_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddCommissionTypes = createAsyncThunk(
  "Shared/AddCommissionTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/commission_types`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateCommissionTypes = createAsyncThunk(
  "Shared/updateCommissionTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/commission_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCommissionTypes = createAsyncThunk(
  "Shared/deleteCommissionTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/commission_types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getPaymentPlans = createAsyncThunk(
  "Shared/getPaymentPlans",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/payment_plans`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddPaymentPlans = createAsyncThunk(
  "Shared/AddPaymentPlans",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/payment_plans`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updatePaymentPlans = createAsyncThunk(
  "Shared/updatePaymentPlans",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/payment_plans/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deletePaymentPlans = createAsyncThunk(
  "Shared/deletePaymentPlans",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/payment_plans/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getStatementTypes = createAsyncThunk(
  "Shared/getStatementTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/statement_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddStatementTypes = createAsyncThunk(
  "Shared/AddStatementTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/statement_types`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateStatementTypes = createAsyncThunk(
  "Shared/updateStatementTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/statement_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteStatementTypes = createAsyncThunk(
  "Shared/deleteStatementTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/statement_types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getContractTypes = createAsyncThunk(
  "Shared/getContractTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/contract_types`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddContractTypes = createAsyncThunk(
  "Shared/AddContractTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/contract_types`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateContractTypes = createAsyncThunk(
  "Shared/updateContractTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/contract_types/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteContractTypes = createAsyncThunk(
  "Shared/deleteContractTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/contract_types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getUserContractReceiptInAccounts = createAsyncThunk(
  "Shared/getUserContractReceiptInAccounts",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/user_contract_receipt_in_accounts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddUserContractReceiptInAccounts = createAsyncThunk(
  "Shared/AddUserContractReceiptInAccounts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/user_contract_receipt_in_accounts`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateUserContractReceiptInAccounts = createAsyncThunk(
  "Shared/updateUserContractReceiptInAccounts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/user_contract_receipt_in_accounts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUserContractReceiptInAccounts = createAsyncThunk(
  "Shared/deleteUserContractReceiptInAccounts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/user_contract_receipt_in_accounts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const SharedSlice = createSlice({
  name: "Shared",
  initialState: {
    isSharedLoading: false,
    error: null,

    FielsArray: null,
    BanksArray: null,
    EducationArray: null,
    IssueStatusArray: null,
    LitigationDegreesArray: null,
    IssueTypesArray: null,
    CourtsArray: null,
    AttributesArray: null,
    IssueDetailStatusArray: null,
    SessionTypesArray: null,
    DocumentTypesArray: null,
    ImplementationTypesArray: null,
    ImplementationPlacesArray: null,
    CommissionTypesArray: null,
    PaymentPlansArray: null,
    StatementTypesArray: null,
    ContractTypesArray: null,
    UserContractReceiptInAccountsArray: null,
  },

  extraReducers: {
    // getFiels
    [getFiels.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getFiels.fulfilled]: (state, action) => {
      state.FielsArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getFiels.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddFiels.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddFiels.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddFiels.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // getBanks
    [getBanks.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getBanks.fulfilled]: (state, action) => {
      state.BanksArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getBanks.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddBank.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddBank.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddBank.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getEducation
    [getEducation.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getEducation.fulfilled]: (state, action) => {
      state.EducationArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getEducation.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddEducation.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddEducation.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddEducation.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getIssueStatus
    [getIssueStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getIssueStatus.fulfilled]: (state, action) => {
      state.IssueStatusArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getIssueStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddIssueStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [updateIssueStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateIssueStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateIssueStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteIssueStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteIssueStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteIssueStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getLitigationDegrees
    [getLitigationDegrees.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getLitigationDegrees.fulfilled]: (state, action) => {
      state.LitigationDegreesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getLitigationDegrees.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddLitigationDegrees.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddLitigationDegrees.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddLitigationDegrees.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateLitigationDegrees
    [updateLitigationDegrees.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateLitigationDegrees.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateLitigationDegrees.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteLitigationDegrees.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteLitigationDegrees.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteLitigationDegrees.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getIssueTypes
    [getIssueTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getIssueTypes.fulfilled]: (state, action) => {
      state.IssueTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getIssueTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddIssueTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateIssueTypes
    [updateIssueTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateIssueTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateIssueTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteIssueTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteIssueTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteIssueTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getCourts
    [getCourts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getCourts.fulfilled]: (state, action) => {
      state.CourtsArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getCourts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddCourts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddCourts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddCourts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateCourts
    [updateCourts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateCourts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateCourts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteCourts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteCourts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteCourts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getAttributes
    [getAttributes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getAttributes.fulfilled]: (state, action) => {
      state.AttributesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getAttributes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddAttributes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddAttributes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddAttributes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateAttributes
    [updateAttributes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateAttributes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateAttributes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteAttributes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteAttributes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteAttributes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getIssueDetailStatus
    [getIssueDetailStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getIssueDetailStatus.fulfilled]: (state, action) => {
      state.IssueDetailStatusArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getIssueDetailStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueDetailStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddIssueDetailStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddIssueDetailStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateIssueDetailStatus
    [updateIssueDetailStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateIssueDetailStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateIssueDetailStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteIssueDetailStatus.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteIssueDetailStatus.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteIssueDetailStatus.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getSessionTypes
    [getSessionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getSessionTypes.fulfilled]: (state, action) => {
      state.SessionTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getSessionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddSessionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddSessionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddSessionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateSessionTypes
    [updateSessionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateSessionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateSessionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteSessionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteSessionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteSessionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getDocumentTypes
    [getDocumentTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getDocumentTypes.fulfilled]: (state, action) => {
      state.DocumentTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getDocumentTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddDocumentTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddDocumentTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddDocumentTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateDocumentTypes
    [updateDocumentTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateDocumentTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateDocumentTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteDocumentTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteDocumentTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteDocumentTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getImplementationTypes
    [getImplementationTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getImplementationTypes.fulfilled]: (state, action) => {
      state.ImplementationTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getImplementationTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddImplementationTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddImplementationTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddImplementationTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateImplementationTypes
    [updateImplementationTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateImplementationTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateImplementationTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteImplementationTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteImplementationTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteImplementationTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getImplementationPlaces
    [getImplementationPlaces.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getImplementationPlaces.fulfilled]: (state, action) => {
      state.ImplementationPlacesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getImplementationPlaces.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddImplementationPlaces.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddImplementationPlaces.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddImplementationPlaces.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateImplementationPlaces
    [updateImplementationPlaces.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateImplementationPlaces.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateImplementationPlaces.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteImplementationPlaces.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteImplementationPlaces.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteImplementationPlaces.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getCommissionTypes
    [getCommissionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getCommissionTypes.fulfilled]: (state, action) => {
      state.CommissionTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getCommissionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddCommissionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddCommissionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddCommissionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateCommissionTypes
    [updateCommissionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateCommissionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateCommissionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteCommissionTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteCommissionTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteCommissionTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getPaymentPlans
    [getPaymentPlans.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getPaymentPlans.fulfilled]: (state, action) => {
      state.PaymentPlansArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getPaymentPlans.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddPaymentPlans.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddPaymentPlans.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddPaymentPlans.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updatePaymentPlans
    [updatePaymentPlans.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updatePaymentPlans.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updatePaymentPlans.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deletePaymentPlans.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deletePaymentPlans.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deletePaymentPlans.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // getStatementTypes
    [getStatementTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getStatementTypes.fulfilled]: (state, action) => {
      state.StatementTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getStatementTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddStatementTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddStatementTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddStatementTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateStatementTypes
    [updateStatementTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateStatementTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateStatementTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteStatementTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteStatementTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteStatementTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getContractTypes
    [getContractTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getContractTypes.fulfilled]: (state, action) => {
      state.ContractTypesArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getContractTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddContractTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddContractTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddContractTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateContractTypes
    [updateContractTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateContractTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateContractTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteContractTypes.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteContractTypes.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteContractTypes.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    // getUserContractReceiptInAccounts
    [getUserContractReceiptInAccounts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [getUserContractReceiptInAccounts.fulfilled]: (state, action) => {
      state.UserContractReceiptInAccountsArray = action.payload.data;
      state.isSharedLoading = false;
    },
    [getUserContractReceiptInAccounts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddUserContractReceiptInAccounts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [AddUserContractReceiptInAccounts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [AddUserContractReceiptInAccounts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
    // updateUserContractReceiptInAccounts
    [updateUserContractReceiptInAccounts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [updateUserContractReceiptInAccounts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [updateUserContractReceiptInAccounts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },

    [deleteUserContractReceiptInAccounts.pending]: (state, action) => {
      state.isSharedLoading = true;
    },
    [deleteUserContractReceiptInAccounts.fulfilled]: (state, action) => {
      state.isSharedLoading = false;
    },
    [deleteUserContractReceiptInAccounts.rejected]: (state, action) => {
      state.isSharedLoading = false;
    },
  },
});

export default SharedSlice.reducer;
